import React from "react";
import PopupHeader from "../PopupHeader";
import Input from "../../Input/Input";
import PrimaryButton from "../../Buttons/PrimaryButton";
import useRejectTimesheetData from "./useRejectTimesheetData";
import { toastError } from "../../Toast/Toast";
import whiteCrossIcon from "../../../assets/images/whiteCrossIcon.svg";
import whiteExlamationIcon from "../../../assets/images/whiteExclamationIcon.svg";

const toastCloseIcon = (
  <img className="mr-2" src={whiteCrossIcon} alt="Close notice" />
);
const toastErrorIcon = <img src={whiteExlamationIcon} alt="Error icon" />;

const RejectTimesheetPopup = ({ popupData, closePopup }) => {
  const {
    popupRef,
    popUpContainerStyles,
    handleDenyTimesheet,
    denyMessage,
    setDenyMessage,
  } = useRejectTimesheetData({
    popupData,
    closePopup,
  });

  return (
    <div ref={popupRef}>
      <PopupHeader headerTitle="Send Back Timesheet?" closePopup={closePopup} />
      <div
        className="px-4 pb-4 rounded-b-lg border-l border-b border-r"
        style={popUpContainerStyles}
      >
        <h1 className="mt-4 text-es-normal font-es-normal mb-4">
          The Time Sheet will be sent back to{" "}
          <span className="font-es-bold">
            {" "}
            {popupData?.timesheet?.employee?.fullName}
          </span>{" "}
          for revision.
        </h1>
        <Input
          isTextarea
          placeholder="Message"
          value={denyMessage}
          onChange={(text) => setDenyMessage(text)}
        />
        <PrimaryButton
          border="primaryGreen"
          fontColor="white"
          className="rounded-md mt-4"
          background="primaryGreen"
          title="Send"
          onClick={() => {
            handleDenyTimesheet((err) => {
              if (err) toastError(err, toastErrorIcon, toastCloseIcon);
            });
          }}
        />
      </div>
    </div>
  );
};

export default RejectTimesheetPopup;
